<div class="dynamic-field form-input-time" [formGroup]="group" [attr.data-test]="config.name">
  <div>
    <cwc-input-time
      [formControlName]="config.name"
      [disabled]="blocked || disabled"
      [format]="config.hourFormat + 'h'"
      [ngClass] = "{ 'input-time-ltr': rtl}"
      [minTime]="min"
      [maxTime]="max"
      [minutesStep]="config.minuteStep ? minuteStep : timeInterval$ | async"
      [placeholder]="config.placeholder | translate"
      [attr.data-test]="config?.dataTId"
      [attr.data-tid]="config?.dataTId"
      [attr.data-name]="config?.name"
      [value]="presetTime"
      [label]="config.label | translate"
      [required]="isRequired$ | async"
      [status]="controlStatus$ | async"
      [statusMessage]="controlStatusMessage$ | async | translate"
      [returnFormat]="config.returnFormat ? config.returnFormat : 'object'"
      [autoSaveOnBlur]="config.autoSaveOnBlur"
      designVersion="v2"
      [disclaimerText]="disclaimerText"
      [nextDay]="nextDay"
      [maxDaysAhead]="maxDaysAhead"
      [initialDate]="initialDate"
    >
    </cwc-input-time>
  </div>
</div>
